<template lang="pug">
  div
    b-form-row
      b-col(v-if="this.$parent.$options.name === 'Cases' && hasVoip")
        b-button(size="sm", :variant="canShowCallHistory ? 'primary' : 'soft-secondary'", @click="canShowCallHistory = !canShowCallHistory").d-flex.align-items-center
          span.mr-1 Historial
          phone-icon.icon-sm
      b-col
        b-dropdown(variant="soft-secondary", size="sm", no-caret, right, class="btn-block", :disabled="!one_case ? selectedCount <= 0 : false")
          template(v-slot:button-content)
            .d-flex.align-items-center.justify-content-between
              span.text-left.text-nowrap.mr-2 Acciones
              chevron-down-icon.icon-md
          component(:is="action.item ? action.item : 'b-dropdown-item'", v-for="(action, index) in availableActions", :key="index", @click="actionManager(action.method)") {{ action.title }}
      //b-col
        b-dropdown#drop-filters(size="sm", variant="light", no-caret, dropright, dropup, boundary="window", :menu-class="['filters-dropdown']")
          template(v-slot:button-content)
            b-spinner(small, v-if="updatingAdmin", variant="secondary")
            component.icon-sm(v-else, :is="sortIcons[admin.sort_cases]")

          b-dropdown-form
            b-form-group(label="Orden de casos", :description="sortDescription" )
              b-form-radio-group(:options="sortOptions", v-model="admin.sort_cases", @change="updateAdminSortCases")
    b-modal(
      v-model="tags_modal",
      size="lg",
      title="Asignar etiquetas",
      cancel-title="Cancelar",
      ok-title="Guardar",
      ok-variant="primary",
      @ok="tags_modal = false; handleAction('tag_ids', tag_ids)",
      scrollable
    )
      div
        b-form-group
          b-input-group(size="sm" )
            b-form-input(placeholder="Buscar etiquetas...", v-model="search_tags", type="search")
            b-input-group-append
              b-input-group-text
                search-icon.text-secondary.icon-sm
        b-card.mb-1.py-2.px-3.shadow(v-for="category in categories", :key="category.tag_category_id", no-body)
          p.text-secondary.mb-1 {{ category.name }}
          b-form-group
            //b-col(sm="6", md="4", lg="3", v-for="(tag, index) in category.tags", :key="index")
            b-form-checkbox.text-wrap(v-for="(tag, index) in category.tags", :key="index", v-model="tag_ids", :value="tag.value", inline) {{ tag.text }}
    b-modal(v-model="group_modal", title="Derivar a grupo", cancel-title="Cancelar", ok-title="Guardar", ok-variant="primary", @ok="handleAction('group_id', group_id)", scrollable)
      .text-center
        b-form-radio-group(v-model="group_id", :options="derivate_groups", buttons, stacked, size="lg", button-variant="outline-primary" )
    b-modal(centered, size="lg", v-model="admin_modal", title="Reasignar administrador", cancel-title="Cancelar", ok-title="Guardar", ok-variant="primary", @ok="handleAction('admin_id', admin_selected)", :ok-disabled="!admin_selected")
      b-input-group.mb-3(size="sm" )
        b-form-input(placeholder="Buscar admin...", v-model="search_admin", type="search")
        b-input-group-append
          b-input-group-text
            search-icon.text-secondary.icon-sm
      b-tabs(justified, nav-class="flex-nowrap scrollable-area overflow-hidden overflow-x pb-1", small)
        b-tab(title="Todos", @click="group_id = null", v-if="$can('read', 'show-all-groups')")
        b-tab(v-for="group in groups", :key="group.value", :title="group.text", @click="loadGroupAdmins(group.value)")
      b-table.scrollable-area.mt-2(ref="adminsTable", :items="parsed_admins", :fields="admin_fields", responsive, :busy="loading_admins", selectable, select-mode="single", @row-selected="selectAdmin", selectedVariant="success", small, sticky-header, hover, style="max-height:500px")
        template(v-slot:empty)
          p.text-help.mb-0.text-center.my-4 {{search_admin.length ? 'No hay coincidencias' : 'No hay agentes creados'}}
        template(v-slot:table-busy)
          .text-center
            b-spinner(variant="primary")
        template(v-slot:cell(first_name)="{ item }")
          b-form-row.align-items-center
            b-col(cols="auto")
              b-avatar.mr-3(size="40px", :src="item.image")
            b-col(cols="auto")
              p.mb-0 {{ item.first_name }} {{ item.last_name }}
              .text-secondary.text-sm {{item.email}}
        template(v-slot:cell(status)="{ item }")
          .text-center(:class="item.current_status.variant || 'text-secondary'") {{ item.current_status.title }}
        template(v-slot:cell(num_open_cases)="{ item }")
          .d-flex.justify-content-between
            div Abiertos:
            .ml-1 {{item.num_open_cases}}
          .d-flex.justify-content-between
            div Espera:
            .ml-1 {{item.num_on_hold_cases}}
      .d-flex.align-items-center.mb-3(v-if="v_paginationShow")
        b-pagination.mb-0.mr-3( size="sm", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getAccountAdmins')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount")
        b-spinner(small, variant="primary", v-if="loading_admins")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { EventBus } from '../helpers/eventBus'
import { UploadFile } from '@/helpers/upload-file'

const tagController = createNamespacedHelpers('tag')
const tagCategoryController = createNamespacedHelpers('tag_category')
const accountController = createNamespacedHelpers('account')
const groupController = createNamespacedHelpers('group')
const caseController = createNamespacedHelpers('case')
const adminController = createNamespacedHelpers('admin')
const platformController = createNamespacedHelpers('platform')

export default {
  name: 'CaseActions',
  data () {
    return {
      actions: [
        {
          title: 'Derivar',
          method: 'case/derivate',
          permission: 'derivate-case'
        },
        {
          title: 'Etiquetar',
          method: 'case/tags'
        },
        {
          title: 'Reasignar',
          method: 'case/assign',
          permission: 'assign-case'
        },
        {
          item: 'b-dropdown-divider',
          multiple: true
        },
        {
          title: 'Abrir casos',
          method: 'open',
          variant: 'success',
          permission: 'open-case',
          multiple: true
        },
        {
          title: 'En espera',
          method: 'on_hold',
          variant: 'primary',
          multiple: true
        },
        {
          title: 'Cerrar casos',
          method: 'close',
          variant: 'danger',
          multiple: true
        },
      ],
      canShowCallHistory: false,
      selected_action: '',
      tags_modal: false,
      updatingAdmin: false,
      tag_ids: [],
      search_tags: '',
      group_modal: false,
      group_id: null,
      admin_modal: false,
      loading_admins: false,
      search_admin: '',
      admin_selected: null,
      derivate_groups: [],
      admins_status: [],
      admin_fields: [
        { key: 'first_name', label: 'Nombre' },
        //{ key: 'email', label: 'Email' },
        { key: 'num_open_cases', label: 'Casos' },
        { key: 'status', label: 'Estado' },
      ],
      admin_statuses: [
        {
          title: 'Disponible',
          variant: 'text-success',
          icon: 'check-circle-icon',
          value: 'available'
        },
        {
          title: 'Pausa administrativa',
          variant: 'text-primary',
          icon: 'clock-icon',
          value: 'backoffice'
        },
        {
          title: 'Descanso',
          variant: 'text-secondary',
          icon: 'coffee-icon',
          value: 'break'
        },
        {
          title: 'Desconectado',
          variant: 'text-secondary',
          icon: 'power-icon',
          value: 'offline'
        }
      ],
      sortOptions: [
        { value: 'DESC', text: 'Descendente' },
        { value: 'ASC', text: 'Ascendente' },
        { value: 'NONE', text: 'No ordenar' }
      ],
      sortIcons: {
        ASC: 'chevrons-up-icon',
        DESC: 'chevrons-down-icon',
        NONE: 'minus-icon'
      }
    }
  },
  props: {
    selected_count: {
      type: Number,
      default: 0
    },
    one_case: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...tagCategoryController.mapState({
      tag_categories: state => state.tag_categories
    }),
    ...tagController.mapState({
      tags: state => state.tags
    }),
    ...groupController.mapState({
      groups: state => state.groups.map(g => {
        return {text: g.name, value: g.group_id}
      })
    }),
    ...accountController.mapState({
      admins: state => state.admins
    }),
    ...caseController.mapState({
      case_object: state => state.case_object
    }),
    ...adminController.mapState({
      admin: state => state.admin
    }),
    ...platformController.mapState({
      platforms: (state) => state.platforms
    }),
    hasVoip() {
      return this.platforms.find(({ name }) => name === 'voip')
    },
    availableActions () {
      return this.actions.filter(el => {
        let has_permission = el.permission ? this.$can('read', el.permission) : true
        if (this.one_case) {
          has_permission = has_permission && !el.multiple
        }
        return has_permission
      })
    },
    categories () {
      try {
        const { Group = {} } = this.case_object
        const { group_id = 'Without Id' } = Group || {}

        return this.tag_categories.map((tag_category) => {
          const { Groups = [] } = tag_category
          const group = Groups.find(group => Number(group.group_id) === group_id)

          if (!group && group_id && Groups.length > 0) return { tags:[] }

          tag_category.tags = this.tags.filter((tag) => tag.tag_category_id == tag_category.tag_category_id)
            .filter(tag => tag.name.search(new RegExp(this.search_tags, "gmi")) >= 0)
            .map(tag => { return { text: tag.name, value: tag.tag_id } })

          return tag_category
        }).filter(tag_category => tag_category.tags.length)
      } catch(e) {

      }
    },
    parsed_admins () {
      return this.admins.map(a => {
        let a_s = this.admins_status.find(el => el.admin_id == a.admin_id)
        let status = this.admin_statuses.find(s => a_s && s.value == a_s.status)
        a.current_status = status || {title: 'Desconectado', value: 'default'}
        return a
      })
    },
    selectedCount () {
      return this.selected_count !== undefined ? this.selected_count : 0
    },
    sortDescription () {
      switch (this.admin.sort_cases) {
        case 'DESC':
          return 'Los casos por atender se ordenan al inicio de la lista'
        case 'ASC':
          return 'Los casos por atender se ordenan al final de la lista'
        case 'NONE':
        default:
          return 'Casos con mensajes nuevos no cambian de posición en la lista'
      }
    },
  },
  methods: {
    ...mapActions([
      'tag/all',
      'group/all',
      'tag_category/all',
      'account/admins',
      'group/all',
      'admin/groups',
      'admin/getStatus',
      'admin/update'
    ]),
    getGroups () {
      if (this.groups.length) {
        this.derivate_groups = this.groups
        return
      }
      const self = this
      this['group/all']({
        account_id: self.$route.params.account_id,
        update_state: true,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          this.derivate_groups = res.resource.map(g => {
            return { text: g.name, value: g.group_id }
          })
        }
      })
    },
    getTagCategories () {
      let self = this
      this['tag_category/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.getTags()
          }
        }
      })
    },
    getTags() {
      let self = this
      this['tag/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    loadGroupAdmins (group_id = null) {
      this.resetPaginationData()
      this.search_admin = ''
      this.group_id = group_id
      this.getAccountAdmins()
    },
    getAccountAdmins () {
      let self = this
      this.loading_admins = true

      let params = {
        show_count_cases: true,
        ...self.paginationParamsObject
      }

      if (this.search_admin) params.name = this.search_admin
      if (this.group_id) params.group_id = this.group_id

      this['account/admins']({
        account_id: self.$route.params.account_id,
        params: params,
        callback: res => {
          this.loading_admins = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
            self.getAdminsStatus()
            if(this.selectedCount > 1){
              this.admin_selected = null
            } else if(this.one_case){
              this.admin_selected = this.case_object.admin_assigned_id
              if(this.admin_selected) {
                const index = this.parsed_admins.findIndex(el => el.admin_id == this.admin_selected)
                if(index >= 0) this.$refs.adminsTable.selectRow(index)
              }
            }
          }
        }
      })
    },
    getAdminsStatus () {
      let self = this

      this['admin/getStatus']({
        params: {
          admin_id: JSON.stringify(self.admins.map(a => a.admin_id)),
          account_id: self.$route.params.account_id,
        },
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.admins_status = res.resource.slice()
          }
        }
      })
    },
    searchAdmins: debounce(function () {
      this.resetPaginationData()
      this.getAccountAdmins()
    }, 800, { leading: false, trailing: true }),
    actionManager(method) {
      this.selected_action = method

      switch (method) {
        case 'case/tags':
          if (this.selectedCount > 1) {
            this.tag_ids = []
          } else if (this.one_case && this.case_object.Tags) {
            this.tag_ids = this.case_object.Tags.map(tag => tag.tag_id)
            EventBus.$emit('getSpecificTags')
          }

          this.tags_modal = !this.tags_modal
          this.search_tags = ''

          break
        case 'case/derivate':
          if (this.selectedCount > 1) {
            this.group_id = null
          } else if (this.one_case) {
            this.group_id = this.case_object.group_id
          }

          this.group_modal = !this.group_modal
          break
        case 'case/assign':
          this.admin_modal = !this.admin_modal
          const first_group_id = this.groups.length ? this.groups[0].value : null
          this.loadGroupAdmins(this.$can('read', 'show-all-groups') ? null : first_group_id)
          break
        case 'on_hold':
          this.selected_action = 'case/update'
          this.holdCase()
          break;
        case 'close':
          this.selected_action = 'case/update'
          this.closeCase()
          break;
        case 'open':
          this.selected_action = 'case/update'
          this.openCase()
          break
      }
    },
    selectAdmin (items) {
      this.admin_selected = items.length ? items[0].admin_id : null
    },
    async openCase () {
      try {
        let response = await this.$bvModal.msgBoxConfirm('¿Deseas abrir los casos seleccionados?', {
          title: 'Abrir casos seleccionados',
          okVariant: 'success',
          okTitle: 'Abrir casos',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.handleAction('status', 'open')
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    async closeCase () {
      try {
        let response = await this.$bvModal.msgBoxConfirm('¿Deseas cerrar los casos seleccionados?', {
          title: 'Cerrar casos seleccionados',
          okVariant: 'danger',
          okTitle: 'Cerrar casos',
          cancelTitle: 'Cancelar',
          okDisabled: 'true'
        })

        if (response) {
          this.handleAction('status', 'close')
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    async holdCase () {
      try {
        let response = await this.$bvModal.msgBoxConfirm('¿Deseas poner en espera los casos seleccionados?', {
          title: 'Poner en espera casos seleccionados',
          okVariant: 'primary',
          okTitle: 'Poner en espera',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.handleAction('status', 'on_hold')
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    handleAction (key, value) {
      let json_data = {}
      json_data[key] = value
      this.$emit('click', { action: this.selected_action, data: json_data })

      if (key === 'tag_ids') return EventBus.$emit('getSpecificTags')
    },
    async updateAdminSortCases(value) {
      this.updatingAdmin = true
      this['admin/update']({
        admin_id: this.admin.admin_id,
        sort_cases: value,
        callback: res => {
          this.updatingAdmin = false

          if (res.error) return this.$message.error(res.error)

          this.$store.commit('group/updateSortType', value)
        }
      })
    },
  },
  mounted () {
    this.getGroups()
    this.getTagCategories()
    EventBus.$on('caseAction/trigger', action => {
      this.actionManager(action)
    })
  },
  beforeDestroy () {
    EventBus.$off('caseAction/trigger')
  },
  watch: {
    canShowCallHistory() {
      this.$emit('canShow', this.canShowCallHistory)
    },
    search_admin () {
      this.searchAdmins()
    }
  }
}
</script>

<style lang="css">
table td {
  vertical-align: middle !important;
}
</style>
